import { render, staticRenderFns } from "./fileView.vue?vue&type=template&id=41f9cd84&scoped=true&"
import script from "./fileView.vue?vue&type=script&lang=js&"
export * from "./fileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f9cd84",
  null
  
)

export default component.exports
import {QBtn,QImg} from 'quasar'
component.options.components = Object.assign({QBtn,QImg}, component.options.components || {})
